import generateUniqueID from "utils/generateUniqueID";
import {
  getRandomDomain,
  getRandomName,
  getRandomPastDate,
  getRandomStatus,
} from "utils/random";
import { defaultDomainData, setDomainData } from "./domainMapper";

export const setDomainUserData = (el = {}) => {
  return {
    createdAt: el.created_at ?? el.CreatedAt ?? null,
    updatedAt: el.updated_at ?? el.UpdatedAt ?? null,
    deletedAt: el.deleted_at ?? el.DeletedAt ?? null,
    lastLoginAt: el.last_login_at ?? null,
    id: el.id ?? el.ID ?? null,
    name: el.full_name || null,
    email: el.email || null,
    status: el.is_active ? "active" : ("deactivated" ?? null),
    domain: setDomainData(
      typeof el.domain === "string"
        ? { domain: el.domain }
        : (el.domain ?? null),
    ),
  };
};
export const defaultDomainUserData = (el = {}) => {
  const date = getRandomPastDate(100);
  const name = getRandomName();
  return {
    CreatedAt: date,
    UpdatedAt: date,
    DeletedAt: null,
    ID: generateUniqueID(),
    name,
    domain: defaultDomainData(),
    email: `${name.replaceAll(" ", "_")}@${getRandomDomain()}`,
    status: el?.status ?? getRandomStatus(),
    is_active: getRandomStatus(true),
  };
};
